//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import DataTableComponent from 'app_components/commons/dataTable'
import PostForm from 'app_components/modules/admin/post'
import PostSkeleton from './postSkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { IPostListItem } from 'app_types/admin/post/postTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../postScreen.scss'

// @ADD Component types
interface IPostScreenLayoutProps {
  itemList: IPostListItem[]
  status: null | 'loading' | 'error'
  add: boolean
  edit: boolean
  view: boolean
  editData: any
  selectedRow: null | string
  pagination: IPagination
  addItem: any
  updateItem: any
  showAddForm: (add: boolean) => void
  showEditForm: (edit: boolean, editData?: any) => void
  onViewerRow: (view: boolean, editData?: any) => void
  onPageChange: (page: number) => void
  onRowClick: (row: any) => void
  removeItem: (userId: string) => void
  onSearch: (search: string) => void
}

const PostScreenLayout: React.FC<IPostScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppContainer>
      <div className='container-fluid'>
        <BreadcrumbComponent links={['#']} texts={[`${t('components.breadcrumb.posts')}`]} />

        <div className='post-screen'>

          {props.status === 'loading' && (
            <PostSkeleton />
          )}

          {props.status !== 'loading' && !props.add && !props.edit && !props.view && (
            <>
              <h2>{t('screens.posts.title')}</h2>

              <DataTableComponent
                data={props.itemList}
                headerKeys={[
                  `${t('components.dataTable.headers.post.title')}`,
                  `${t('components.dataTable.headers.post.type')}`,
                  `${t('components.dataTable.headers.post.isActive')}`,
                ]}
                keys={['title', 'postType.name', 'isActive']}
                selectedRow={props.selectedRow}
                pagination={props.pagination}
                detailsKey={[
                  { name: `${t('components.dataTable.details.post.locations')}`, key: 'locations.postLocation.name', listItem: true },
                ]}
                onSearch={props.onSearch}
                onAddRow={props.showAddForm}
                onClickRow={props.onRowClick}
                onRemoveRow={props.removeItem}
                onPageChange={props.onPageChange}
                onEditRow={props.showEditForm}
                onViewerRow={props.onViewerRow}
                onModal={null}
              />
            </>
          )}

          {props.add && (
            <div className="post-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                <h2 className="form-title">
                  {t("screens.posts.add_layout.title_page")}
                </h2>
                <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showAddForm(false)}>
                  {t("buttons.back")}
                </button>
              </div>
              <PostForm
                onHandleSubmit={props.addItem}
                viewer={false}
              />
            </div>
          )}

          {(props.edit || props.view) && props.editData && (
            <div className="post-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                {props.edit && (
                  <>
                    <h2 className="form-title">
                      {t("screens.posts.edit_layout.title_page")}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showEditForm(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
                {props.view && (
                  <>
                    <h2 className="form-title">
                      {t("screens.posts.view_layout.title_page")}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.onViewerRow(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
              </div>
              <PostForm
                editData={props.editData}
                onHandleSubmit={props.updateItem}
                viewer={props.view}
              />
            </div>
          )}
        </div>
      </div>
    </AppContainer>
  )
}

export default PostScreenLayout
